import { Component, OnDestroy } from '@angular/core';
import { AbstractControl, FormBuilder } from '@angular/forms';
import { StorageService } from '@morningstar/shared/base/storage-service';
import { select } from '@morningstar/shared/operators';
import { merge } from 'rxjs';
import { filter, startWith, tap } from 'rxjs/operators';
import { DashboardBaseComponent } from '../../dashboard-base/dashboard-base.component';
import { MeetingRoomSelectors } from '../meeting-room.selectors';
import { MeetingRoomService } from '../meeting-room.service';
import { MeetingRoomRequirements } from './meeting-room-requirements';

@Component({
  selector: 'wsg-meeting-room-requirements',
  templateUrl: './meeting-room-requirements.component.html',
  styleUrls: ['./meeting-room-requirements.component.scss', '../../dashboard.scss'],
})
export class MeetingRoomRequirementsComponent extends DashboardBaseComponent implements OnDestroy {

  // == CONSTANTS =======================================================

  title = 'Meeting Room Requirements';

  // == STATE ===========================================================

  form = this.formBuilder.group({
    location: '',
    date: new Date()
  });

  state$ = this.meetingRoomService.state$;

  // == INTERMEDIATE ====================================================

  requirements$ = this.state$.pipe(select<MeetingRoomRequirements[]>(MeetingRoomSelectors.meetingRoomRequirements));

  date$ = this.date.valueChanges;
  location$ = this.location.valueChanges.pipe(
    startWith('')
  );

  // == SIDE EFFECTS ====================================================

  onGetRequirements$ = merge(
    this.location$,
    this.date$
  ).pipe(
    filter(_ => !!this.location.value && !!this.date.value),
    tap(_ => this.meetingRoomService.getRequirements(this.location.value, this.date.value))
  );

  // == SUBSCRIPTION ====================================================

  subscription = merge(
    this.onGetRequirements$
  ).subscribe();

  // == LIFECYCLE =======================================================

  constructor(private meetingRoomService: MeetingRoomService,
              private formBuilder: FormBuilder,
              protected storageService: StorageService) { 
    super(storageService);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  // == HELPERS =========================================================

  get location(): AbstractControl {
    return this.form.get('location');
  }

  get date(): AbstractControl {
    return this.form.get('date');
  }
}
